import '../Assests/css/views/achievements.css';

export default function Achievements() {
    return (
        <section id="achievements" className="achievements">
            <h1>ACHIEVEMENTS</h1>
            
            <div className="achievement-intro">
                <p>Throughout my academic and professional journey, I have been fortunate to achieve several milestones that reflect my dedication, skills, and passion for technology.</p>
            </div>

            <div className="achievement-cards-grid">
                <div className="achievement-card">
                    <h2 className="achievement-title">President's List Recognition</h2>
                    <p className="achievement-description">Consistently recognized on the President's List for maintaining a high GPA throughout my studies at PUP Main Campus.</p>
                </div>
                
                <div className="achievement-card">
                    <h2 className="achievement-title">Hackathon Participation</h2>
                    <p className="achievement-description">Participated in various hackathons, where I collaborated with teams to develop innovative solutions and won awards for creativity and technical excellence.</p>
                </div>
                
                <div className="achievement-card">
                    <h2 className="achievement-title">Technical Certifications</h2>
                    <p className="achievement-description">Earned certifications in AI development(OCI Associate), API Development(Postman Student Expert),Backend developement demonstrating my commitment to continuous learning and professional growth.</p>
                </div>
                
                <div className="achievement-card">
                    <h2 className="achievement-title">Mentor/Senior Backend Engineer | AWS Cloud Club PUP | 2023 - 2025</h2>
                    <p className="achievement-description">Mentored junior developers in PHP and SQL fundamentals through practical modules and hands-on exercises. Designed backend training modules, improving onboarding speed and skill growth for new members.</p>
                </div>
            </div>
        </section>
    );
}